import { render, staticRenderFns } from "./DataSharingCell.vue?vue&type=template&id=f1635806&"
import script from "./DataSharingCell.vue?vue&type=script&lang=js&"
export * from "./DataSharingCell.vue?vue&type=script&lang=js&"
import style0 from "./DataSharingCell.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports